// Local
/*var backofficeUrl = 'http://127.0.0.1:8090/#'
var baseUrl = 'http://127.0.0.1:8080/servicecomplet/api/v1'*/

// Recette
/* var backofficeUrl = 'http://servicecomplet-bo-rec.suez.fr/#'
var baseUrl = 'https://servicecomplet-bo-rec-api.suez.fr/servicecomplet/api/v1'*/

// Hml
/*var backofficeUrl = 'https://servicecomplet-bo-preprod.suez.fr/#'
var baseUrl = 'https://servicecomplet-bo-hml-api.suez.fr/servicecomplet/api/v1'*/

// Prod
var backofficeUrl = 'https://servicecomplet-bo.suez.fr/#'
var baseUrl = 'https://servicecomplet-bo-api.suez.fr/servicecomplet/api/v1'

// Prod (Azure)
/*var backofficeUrl = 'https://webapp-servicecomplet-bo-prd.azurewebsites.net/#'
var baseUrl = 'https://webapp-servicecomplet-back-prd.azurewebsites.net/servicecomplet/api/v1'*/

export {baseUrl, backofficeUrl}



// WEBPACK FOOTER //
// ./src/config.js